import theme from '../../base';

const select = {
  background: theme.colors.neutrals.white,
  border: theme.colors.neutrals.gray500,
  foreground: theme.colors.neutrals.gray700,
  labelForeground: theme.colors.neutrals.gray700,
  disabled: {
    background: theme.colors.neutrals.gray250,
    border: theme.colors.neutrals.gray500,
    foreground: theme.colors.neutrals.gray500,
  },
  focus: {
    border: theme.colors.blues.blue500,
  },
  error: {
    border: theme.colors.reds.red500,
  },
};

export default select;
